import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ReceiptSourceFacetsQueryVariables = Types.Exact<{
  publicId: Types.Scalars["String"];
}>;

export type ReceiptSourceFacetsQuery = {
  __typename?: "Query";
  receiptSourceFacets: {
    __typename?: "ReceiptSourceFacets";
    uploadSources: Array<Types.DocumentUploadSource>;
    documentOrigins: Array<string>;
  };
};

export const ReceiptSourceFacetsDocument = gql`
  query receiptSourceFacets($publicId: String!) {
    receiptSourceFacets(publicId: $publicId) {
      uploadSources
      documentOrigins
    }
  }
`;

/**
 * __useReceiptSourceFacetsQuery__
 *
 * To run a query within a React component, call `useReceiptSourceFacetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceiptSourceFacetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceiptSourceFacetsQuery({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useReceiptSourceFacetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReceiptSourceFacetsQuery,
    ReceiptSourceFacetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReceiptSourceFacetsQuery,
    ReceiptSourceFacetsQueryVariables
  >(ReceiptSourceFacetsDocument, options);
}
export function useReceiptSourceFacetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReceiptSourceFacetsQuery,
    ReceiptSourceFacetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReceiptSourceFacetsQuery,
    ReceiptSourceFacetsQueryVariables
  >(ReceiptSourceFacetsDocument, options);
}
export type ReceiptSourceFacetsQueryHookResult = ReturnType<
  typeof useReceiptSourceFacetsQuery
>;
export type ReceiptSourceFacetsLazyQueryHookResult = ReturnType<
  typeof useReceiptSourceFacetsLazyQuery
>;
export type ReceiptSourceFacetsQueryResult = Apollo.QueryResult<
  ReceiptSourceFacetsQuery,
  ReceiptSourceFacetsQueryVariables
>;
